module.exports = __webpack_public_path__ + "img/flower.3c62a55a.svg";